import lottie from 'lottie-web';

export default class LoadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'LoadScene' });
  }

  preload() {
    this.load.json('loading-anim', 'assets/loadAnims_lottie/cuemath_loading.json');
  }

  create() {
    this.loadingAnim = this.addLoaderLottie(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
    );

    this.startSceneAssetsLoad();
    this.load.start();

    this.load.on('progress', () => {
      this.loadingAnim.anim.playSegments([0, 25], true);
    });

    this.load.on('complete', () => {
      this.loadingAnim.anim.loop = false;
      this.loadingAnim.anim.playSegments([26, 41], true);
      this.loadingAnim.anim.addEventListener('complete', () => {
        this.scene.stop('LoadScene');
        this.scene.start('StartScene');
      });
    });
  }

  addLoaderLottie(_x, _y) {
    const lottieRef = this.add
      .dom(_x - this.cameras.main.width / 2, _y - this.cameras.main.height / 2, 'div')
      .setScale(0.7);

    const lottieDiv = lottieRef.node;
    lottieDiv.style.height = '100%';
    lottieDiv.style.width = '100%';

    const lottieAnim = lottie.loadAnimation({
      container: lottieDiv,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      animationData: this.cache.json.get('loading-anim'),
    });

    return { anim: lottieAnim, dom: lottieRef };
  }

  startSceneAssetsLoad() {
    for (let j = 0; j < 11; j++) {
      for (let i = 0; i < 4; i++) {
        this.load.image(j + '_' + i, 'assets/GameSceneAssets/' + j + '_' + i + '.png');
        this.load.image(
          j + '_' + i + '_c',
          'assets/GameSceneAssets/' + j + '_' + i + '_c.png',
        );
        this.load.image(
          j + '_' + i + '_w',
          'assets/GameSceneAssets/' + j + '_' + i + '_w.png',
        );
      }
    }

    this.load.plugin(
      'rexkawaseblurpipelineplugin',
      'assets/EndSceneAssets/rexkawaseblurpipelineplugin.min.js',
      true,
    );
    this.load.plugin('rexwarppipelineplugin', 'assets/warp.min.js', true);

    this.load.image('play_button', 'assets/StartSceneAssets/play_button.png');
    this.load.atlas('bubbleOne', 'assets/anims/bubbleOneAnim.png', 'assets/anims/bubbleOneAnim.json');
    this.load.atlas('octopusAnim', 'assets/anims/octopusAnim-0.png', 'assets/anims/octopusAnim.json');
    this.load.atlas('bubbleBurstAnim', 'assets/anims/bubbleBurstAnim.png', 'assets/anims/bubbleBurstAnim.json');

    this.load.image('gameName', 'assets/StartSceneAssets/gameName.png');
    this.load.image('play_button_on', 'assets/StartSceneAssets/play_button_on.png');
    this.load.image('sbg', 'assets/StartSceneAssets/sbg.png');
    this.load.image('sbg2', 'assets/StartSceneAssets/sbg2.png');
    this.load.image('sbg3', 'assets/StartSceneAssets/sbg3.png');
    this.load.image('sbg4', 'assets/StartSceneAssets/sbg4.png');
    this.load.image('sbg5', 'assets/StartSceneAssets/sbg5.png');

    this.load.image('fish', 'assets/StartSceneAssets/fish.png');
    this.load.image('weed', 'assets/StartSceneAssets/weed.png');
    this.load.image('gweed', 'assets/GameSceneAssets/weed.png');
    this.load.image('gweed2', 'assets/GameSceneAssets/gweed2.png');
    this.load.image('rock', 'assets/GameSceneAssets/rock.png');

    this.load.atlas('gemCorrectAnim', 'assets/anims/gemCorrectAnim.png', 'assets/anims/gemCorrectAnim.json');
    this.load.atlas('gemShutNormalAnim', 'assets/anims/gemShutNormalAnim.png', 'assets/anims/gemShutNormalAnim.json');
    this.load.atlas('gemWrongAnim', 'assets/anims/gemWrongAnim-0.png', 'assets/anims/gemWrongAnim.json');

    this.load.multiatlas('jiggiWrongAnim', 'assets/anims/jiggiWrongAnim.json', 'assets/anims/');
    this.load.multiatlas('jiggiIdleAnim', 'assets/anims/jiggiIdleAnim.json', 'assets/anims/');
    this.load.atlas('gemWrongOpenAnim', 'assets/anims/gemWrongOpenAnim-0.png', 'assets/anims/gemWrongOpenAnim.json');

    this.load.multiatlas('jiggiSwimAnim', 'assets/anims/jiggiSwimAnim.json', 'assets/anims/');

    this.load.video('vid', 'assets/GameSceneAssets/vid.mp4');
    this.load.image('highlight', 'assets/GameSceneAssets/highlight.png');
    this.load.image('hand', 'assets/GameSceneAssets/hand.png');

    this.load.image('bubble', 'assets/GameSceneAssets/Bubble.png');
    this.load.image('bubble_c', 'assets/GameSceneAssets/Bubble_c.png');
    this.load.image('bubble_w', 'assets/GameSceneAssets/Bubble_w.png');

    this.load.atlas('hintFinalAnim', 'assets/HintSceneAssets/hintFinalAnim.png', 'assets/HintSceneAssets/hintFinalAnim.json');
    this.load.image('hintClose', 'assets/HintSceneAssets/closeHint.png');
    this.load.image('hintText', 'assets/HintSceneAssets/hintText.png');
    this.load.image('hintText2', 'assets/HintSceneAssets/hintText2.png');

    this.load.image('overlay', 'assets/GameSceneAssets/overlay.png');

    this.load.image('compass', 'assets/anims/rewardAnims/compass.png');
    this.load.multiatlas('glitter', 'assets/anims/rewardAnims/glitterAnim.json', 'assets/anims/rewardAnims/');
    this.load.multiatlas('baseCircle', 'assets/anims/rewardAnims/baseCircleAnim.json', 'assets/anims/rewardAnims/');
    this.load.multiatlas('rewardLight', 'assets/anims/rewardAnims/rewardLightAnim.json', 'assets/anims/rewardAnims/');
    this.load.image('gameOver', 'assets/EndSceneAssets/Game Over.png');
    this.load.image('youWon', 'assets/EndSceneAssets/You won.png');
    this.load.image('correctIcon', 'assets/EndSceneAssets/correctIcon.png');
    this.load.image('incorrectIcon', 'assets/EndSceneAssets/incorrectIcon.png');
    this.load.image('retryButton', 'assets/EndSceneAssets/Retry Button.png');
    this.load.image('hover_retryButton', 'assets/EndSceneAssets/hover_Retry Button.png');
    this.load.image('hintIconMini', 'assets/EndSceneAssets/endHint.png');
    this.load.image('nextButton', 'assets/EndSceneAssets/nextButton.png');
    this.load.image('hover_nextButton', 'assets/EndSceneAssets/hover_nextbutton.png');
    this.load.image('replayButton', 'assets/EndSceneAssets/replayButton.png');
    this.load.image('hover_replayButton', 'assets/EndSceneAssets/hover_replayButton.png');
    this.load.image('endScreenOverlay', 'assets/EndSceneAssets/end screen.png');
    this.load.image('okayButton', 'assets/EndSceneAssets/okaybutton.png');
    this.load.image('hover_okayButton', 'assets/EndSceneAssets/hover_okaybutton.png');
    this.load.image('disable_okayButton', 'assets/EndSceneAssets/disable_okaybutton.png');
    this.load.image('rewardEarned', 'assets/EndSceneAssets/Rewards earned!.png');
    this.load.image('star', 'assets/EndSceneAssets/star.png');
    this.load.image('rewardName', 'assets/EndSceneAssets/PEARL.png');

    this.load.multiatlas('endConfetti', 'assets/EndSceneAssets/confetti/confettiAnimNew.json', 'assets/EndSceneAssets/confetti');
    this.load.multiatlas('spotlight', 'assets/EndSceneAssets/spotlight/spotlightAnimNew.json', 'assets/EndSceneAssets/spotlight');

    this.load.audio('reward_reveal', 'assets/Audio/reward_reveal.mp3');
    this.load.audio('confettiaudio', 'assets/Audio/confetti.wav');

    this.load.image('T1', 'assets/GameSceneAssets/T1.png');
    this.load.image('T2', 'assets/GameSceneAssets/T2.png');
    this.load.image('T3', 'assets/GameSceneAssets/T3.png');

    for (let i = 1; i <= 9; i++) {
      this.load.image('Q' + i, 'assets/GameSceneAssets/Q' + i + '.png');
    }

    // GAME UI
    this.load.image('q', 'assets/q.png');
    this.load.image('correct', 'assets/correct.png');
    this.load.image('wrong', 'assets/wrong.png');
    this.load.image('progress', 'assets/progress.png');

    this.load.image('hint', 'assets/Hint.png');
    this.load.image('hint1', 'assets/hint1.png');
    this.load.image('closeHint', 'assets/closeHintIconhdpi.png');

    this.load.image('mask', 'assets/mask.png');
    this.load.image('progressBar', 'assets/progressBar.png');
    this.load.image('holder', 'assets/holder.png');
    this.load.image('settings', 'assets/settings.png');
    this.load.image('yellow', 'assets/yellow.png');
    this.load.image('circle', 'assets/circle.png');
    this.load.image('dropDown', 'assets/dropDown.png');
    this.load.image('fullScreenOff', 'assets/fullScreenOff.png');
    this.load.image('fullScreen', 'assets/fullScreen.png');
    this.load.image('sound', 'assets/sound.png');
    this.load.image('mute', 'assets/mute.png');
    this.load.image('paused', 'assets/paused.png');

    this.load.multiatlas('playAnim', 'assets/Game UI Anims/Tera Animations/playPauseAnim.json', 'assets/Game UI Anims/Tera Animations');
    this.load.multiatlas('teraIn', 'assets/Game UI Anims/Tera Animations/teraAppearAnim.json', 'assets/Game UI Anims/Tera Animations');
    this.load.multiatlas('teraIdle', 'assets/Game UI Anims/Tera Animations/teraIdleBlinkAnim.json', 'assets/Game UI Anims/Tera Animations');
    this.load.multiatlas('teraCorrect', 'assets/Game UI Anims/Tera Animations/teraCorrectAnim.json', 'assets/Game UI Anims/Tera Animations');
    this.load.multiatlas('teraWrong', 'assets/Game UI Anims/Tera Animations/teraWrongAnim.json', 'assets/Game UI Anims/Tera Animations');
    this.load.multiatlas('teraThink', 'assets/Game UI Anims/Tera Animations/teraThinkAnim.json', 'assets/Game UI Anims/Tera Animations');
    this.load.multiatlas('teraIdea', 'assets/Game UI Anims/Tera Animations/teraIdeaAnim.json', 'assets/Game UI Anims/Tera Animations');
    this.load.multiatlas('teraOut', 'assets/Game UI Anims/Tera Animations/teraOutAnim.json', 'assets/Game UI Anims/Tera Animations');

    this.load.audio('bgaudio', 'assets/Audio/bgaudio.mp3');
    this.load.audio('correctaudio', 'assets/Audio/correct.mp3');
    this.load.audio('wrongaudio', 'assets/Audio/wrong.mp3');
  }

  update() {}
}
